<template>
  <div class="content-wrapper">
    <div class="content-header">
      <div
        class="d-flex align-items-center"
        style="border-bottom: 1px solid #5c4a4a17; margin: auto !important"
      >
        <div class="row">
          <div class="col-sm-6 d-flex flex-column align-items-baseline">
            <h1 class="m-0 text-dark">Server Performance</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Dashboard' }"
                >Dashboard</router-link
              >
              <li class="breadcrumb-item active">Server Performance:</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :loading="loading"
        :items-per-page="itemsPerPage"
        :page="page"
        :disable-pagination="loading"
        :server-items-length="totalLength"
        :hide-default-footer="true"
        :footer-props="{
          'items-per-page-options': [25, 50, 100, 200],
          class: 'td--visualize-sticky',
        }"
        @update:page="onPageChange"
        class="elevation-1 data-explorer__v-data-table"
      >
        <template v-slot:top>
          <div class="d-flex align-items-center justify-space-between">
            <v-form
              ref="form"
              v-model="isFormValid"
              lazy-validation
              class="w-100"
            >
              <div class="d-flex align-items-center mt-3">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value="datePicker"
                  :max="maxDate"
                  transition="scale-transition"
                  offset-y
                  max-width="500px"
                  max-height="500px !important"
                  style="max-height: max-content !important"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="datePickerRangeText"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      full-width
                      v-bind="attrs"
                      v-on="on"
                      :disabled="loading"
                      :loading="loading"
                      :rules="requiredRule"
                      required
                      class="px-2"
                      style="max-width: fit-content; min-width: 280px"
                    ></v-text-field>
                  </template>
                  <v-container>
                    <v-row
                      class="v-menu--container__width"
                      justify="space-around"
                      align-content="center"
                    >
                      <v-col cols="7">
                        <v-row>
                          <v-col cols="7">
                            <v-autocomplete
                              v-model="selectedTimezone"
                              :items="timezones"
                              :rules="requiredRule"
                              :disabled="loading"
                              :loading="loading"
                              class="mb-2"
                              auto-select-first
                              dense
                              outlined
                            ></v-autocomplete
                          ></v-col>
                          <v-col cols="5" class="px-0">
                            <v-autocomplete
                              v-model="selectedDateTrunc"
                              :items="[
                                {
                                  text: 'Hour',
                                  value: 'hour',
                                },
                                {
                                  text: 'Day',
                                  value: 'day',
                                },
                              ]"
                              :rules="requiredRule"
                              :disabled="loading"
                              :loading="loading"
                              class="px-2"
                              auto-select-first
                              dense
                              outlined
                            >
                            </v-autocomplete>
                          </v-col>
                        </v-row>

                        <v-date-picker
                          v-model="datePicker"
                          range
                          no-title
                          scrollable
                          :min="minDate"
                          :max="maxDate"
                          :disabled="loading"
                          :loading="loading"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(datePicker)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-col>
                      <v-col cols="3" class="py-0">
                        <v-chip-group
                          v-model="selectedDateRangePreset"
                          column
                          class="v-chip-group--width"
                        >
                          <v-chip
                            v-for="tag in [
                              'Today',
                              'Yesterday',
                              'Last 7 days',
                              'This month',
                              'Last month',
                              'Last 30 days',
                              'Last 3 months',
                              // 'Last 6 months',
                            ]"
                            :key="tag"
                            :value="tag"
                            outlined
                          >
                            {{ tag }}
                          </v-chip>
                        </v-chip-group></v-col
                      >
                    </v-row>
                  </v-container>
                </v-menu>
                <v-autocomplete
                  v-if="isModerRole"
                  v-model="selectedClient"
                  :items="getClients"
                  :rules="requiredRule"
                  :disabled="loading"
                  :loading="loading"
                  :search-input.sync="clientSearchValue"
                  :cache-items="true"
                  item-text="name"
                  item-value="client_uid"
                  label="Clients"
                  multiple
                  outlined
                  required
                  dense
                  class="pa-2"
                  style="max-width: fit-content; min-width: 150px"
                >
                  <template v-slot:prepend-item>
                    <v-text-field
                      v-model="clientSearchValue"
                      :loading="loading"
                      :disabled="loading"
                      outlined
                      dense
                      class="px-2 mt-5"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-divider class="m-0 mb-5"></v-divider>
                    <v-checkbox
                      :input-value="areAllClientsSelected"
                      label="Select All"
                      @change="toggleClientsSelectAll"
                      color="primary"
                      class="pl-4"
                    >
                    </v-checkbox>
                    <v-divider class="m-0 mb-4"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <p
                      v-if="
                        index === 0 && selectedClient.length < getClients.length
                      "
                      class="text-transform--ellipsis mb-0"
                    >
                      {{ item.name }}
                    </p>
                    <span
                      v-if="
                        index === 1 &&
                        selectedClient.length !== getClients.length
                      "
                      class="m-0 p-0 grey--text text-caption v-chip__width"
                    >
                      (+
                      {{ selectedClient.length - 1 }})
                    </span>
                    <p
                      v-else-if="
                        index === 0 &&
                        selectedClient.length === getClients.length
                      "
                      class="mb-0"
                    >
                      All
                    </p>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-model="selectedDomain"
                  :items="domains"
                  :rules="requiredRule"
                  :loading="loading"
                  :disabled="loading"
                  :filter="filterDomains"
                  :search-input.sync="domainSearchValue"
                  multiple
                  item-text="url"
                  item-value="website_id"
                  label="Domains"
                  outlined
                  required
                  dense
                  class="pa-2"
                  style="max-width: fit-content; min-width: 150px"
                >
                  <template v-slot:prepend-item>
                    <v-text-field
                      v-model="domainSearchValue"
                      :loading="loading"
                      :disabled="loading"
                      outlined
                      dense
                      class="px-2 mt-5"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-divider class="m-0 mb-5"></v-divider>
                    <v-checkbox
                      :input-value="areAllDomainsSelected"
                      label="Select All"
                      @change="toggleDomainsSelectAll"
                      color="primary"
                      class="pl-4"
                    >
                    </v-checkbox>
                    <v-divider class="m-0 mb-4"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <p
                      v-if="
                        index === 0 && selectedDomain.length < domains.length
                      "
                      class="text-transform--ellipsis mb-0"
                    >
                      {{ item.url }}
                    </p>
                    <span
                      v-if="
                        index === 1 && selectedDomain.length !== domains.length
                      "
                      class="m-0 p-0 grey--text text-caption v-chip__width"
                    >
                      (+
                      {{ selectedDomain.length - 1 }})
                    </span>
                    <p
                      v-else-if="
                        index === 0 && selectedDomain.length === domains.length
                      "
                      class="mb-0"
                    >
                      All
                    </p>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  v-model="selectedGroupBy"
                  :items="itemsToGroupBy"
                  :loading="loading"
                  :disabled="loading"
                  :rules="requiredRule"
                  label="Group By"
                  multiple
                  outlined
                  dense
                  class="pa-2"
                  style="min-width: 135px; max-width: max-content"
                >
                  <template v-slot:prepend-item>
                    <v-checkbox
                      :input-value="areAllGroupBySelected"
                      label="Select All"
                      @change="toggleGroupBySelectAll"
                      color="primary"
                      class="pl-4"
                    >
                    </v-checkbox>
                    <v-divider class="m-0 mb-4"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <p
                      v-if="
                        index === 0 &&
                        selectedGroupBy.length < itemsToGroupBy.length
                      "
                      class="text-transform--ellipsis mb-0 pl-1"
                    >
                      {{ item.text }}
                    </p>
                    <span
                      v-if="index === 1 && selectedGroupBy.length !== 6"
                      class="m-0 p-0 grey--text text-caption v-chip__width"
                    >
                      (+
                      {{ selectedGroupBy.length - 1 }})
                    </span>
                    <p
                      v-else-if="
                        index === 0 &&
                        selectedGroupBy.length === itemsToGroupBy.length
                      "
                      class="mb-0"
                    >
                      All
                    </p>
                  </template>
                </v-autocomplete>
              </div>
            </v-form>
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="primary"
              class="mr-5 mb-5"
              :loading="loading"
              :disabled="loading"
              @click="exportData"
            >
              <v-icon>mdi-tray-arrow-down</v-icon>
            </v-btn>
            <v-btn
              color="primary"
              class="mr-3 mb-5"
              :loading="loading"
              :disabled="loading"
              @click.stop="applySettings"
              >Get Data</v-btn
            >
          </div>
        </template>
        <template v-slot:[`item.date`]="{ item }">
          <p class="mb-0">{{ formatDate(item.date) }}</p>
        </template>
        <template v-slot:[`item.client_uid`]="{ item }">
          <p class="mb-0">{{ filteredClientName(item.client_uid) || "" }}</p>
        </template>
        <template v-slot:[`item.sent`]="{ item }">
          <p class="mb-0">{{ formatNumberWithCommas(item.sent) }}</p>
        </template>
        <template v-slot:[`item.delivered`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.delivered) }}
          </p>
        </template>
        <template v-slot:[`item.clicked`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.clicked) }}
          </p>
        </template>
        <template v-slot:[`item.subscribed`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.subscribed) }}
          </p>
        </template>
        <template v-slot:[`item.unsubscribed`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.unsubscribed) }}
          </p>
        </template>
        <template v-slot:[`item.count_setup_drips_per_hour`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.count_setup_drips_per_hour) }}
          </p>
        </template>
        <template v-slot:[`item.count_setup_drips_per_day`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.count_setup_drips_per_day) }}
          </p>
        </template>
        <template v-slot:[`item.sent_per_hour_by_uniq_drips`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.sent_per_hour_by_uniq_drips) }}
          </p>
        </template>
        <template v-slot:[`item.count_drips_per_hour_by_sent`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.count_drips_per_hour_by_sent) }}
          </p>
        </template>
        <template v-slot:[`item.count_drips_per_day_by_sent`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.count_drips_per_day_by_sent) }}
          </p>
        </template>
        <template v-slot:[`item.active_subs_last_3_days`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.active_subs_last_3_days) }}
          </p>
        </template>
        <template v-slot:[`item.active_subs_by_hour_last_3_days`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.active_subs_by_hour_last_3_days) }}
          </p>
        </template>
        <template v-slot:[`item.sent_per_day_by_uniq_drips`]="{ item }">
          <p class="mb-0">
            {{ formatNumberWithCommas(item.sent_per_day_by_uniq_drips) }}
          </p>
        </template>
        <template v-slot:[`item.campaign_uid`]="{ item }">
          <v-skeleton-loader
            v-if="loading && items.length"
            type="table-cell"
            class="width-280"
          ></v-skeleton-loader>
          <p
            class="text-transform--ellipsis width-280 c-pointer m-0"
            v-if="!loading && items.length"
          >
            <!-- {{ item.campaign_uid }} - {{ selectedDomainWebsite(item.campaign_uid) }} -->
            {{
              selectedDomainWebsite(item.campaign_uid) !== undefined
                ? selectedDomainWebsite(item.campaign_uid).id
                : ""
            }}
            -
            {{
              selectedDomainWebsite(item.campaign_uid) !== undefined
                ? selectedDomainWebsite(item.campaign_uid).url
                : ""
            }}
          </p>
        </template>
        <template v-slot:[`body.append`]>
          <tr>
            <td
              :colspan="headers.length"
              class="text-center relative"
              style="position: relative"
            >
              <v-btn
                icon
                :disabled="page === 1"
                @click.stop="onPageChange((page -= 1))"
                class="pagination-btns chevron--left"
                ><v-icon>mdi-chevron-left</v-icon></v-btn
              >
              <v-btn
                icon
                :disabled="items.length < itemsPerPage"
                @click="onPageChange((page += 1))"
                class="pagination-btns chevron--right"
                ><v-icon>mdi-chevron-right</v-icon></v-btn
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <!-- Success Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        @update-success="handleUpdateToSuccessSnackbar"
        :message="successMessage"
      />
    </transition>

    <!-- Failure Snackbar -->
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        @update-failure="handleUpdateToFailureSnackbar"
        :message="failureMessage"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import SuccessSnackbar from "../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import common from "../../mixins/common";
import { serializeObjToQueryParams } from "../../utils";
import Statistics from "../../apis/Statistics";
import { EchoService } from "../../services/EchoService";

const momentTimezone = require("moment-timezone");

export default {
  name: "ServerPerformance",
  mixins: [common],
  components: {
    SuccessSnackbar,
    FailureSnackbar,
  },
  data() {
    return {
      items: [],
      itemsToGroupBy: [
        {
          text: "Welcome",
          value: "welcome",
        },
        {
          text: "Recurring",
          value: "recurring",
        },
      ],
      headers: [
        {
          text: "Domain",
          value: "campaign_uid",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Date",
          value: "date",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Type",
          value: "type",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Setup\\d",
          value: "count_setup_drips_per_day",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Setup\\h",
          value: "count_setup_drips_per_hour",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Sent",
          value: "sent",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Sent pushes\\d",
          value: "count_drips_per_day_by_sent",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Sent pushes\\h",
          value: "count_drips_per_hour_by_sent",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Match ratio",
          value: "match_ratio",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Subs",
          value: "subscribed",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Unsubs",
          value: "unsubscribed",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Deactivates",
          value: "deactivated",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
        {
          text: "Funsubs",
          value: "full_unsubscribed",
          sortable: true,
          align: "left",
          width: "130px",
          class: "table-header--color",
        },
      ],
      totalItems: {},
      selectedColumns: [],
      selectedGroupBy: ["welcome", "recurring"],

      dialog: false,
      selectedClient: [],
      selectedFilters: null,
      selectedDomain: [],
      selectedItems: null,
      selectedTimezone: momentTimezone.tz.guess(),
      timezones: momentTimezone.tz.names(),
      loading: false,
      isSettingsDialog: false,
      clientSearchValue: "",
      domainSearchValue: "",

      menu: false,
      requiredRule: [
        (v) => (Array.isArray(v) ? !!v.length : !!v || "Field is required."),
      ],
      datePicker: [
        moment().subtract(1, "weeks").format("YYYY-MM-DD"),
        moment().subtract(1, "day").format("YYYY-MM-DD"),
      ],
      selectedDateRangePreset: null,
      minDate: moment().subtract(2, "months").format("YYYY-MM-DD"),
      maxDate: moment().format("YYYY-MM-DD"),
      selectedTimezone: momentTimezone.tz.guess(),
      timezones: momentTimezone.tz.names(),

      isFormValid: false,
      success: false,
      successMessage: "",
      failure: false,
      failureMessage: "",

      page: 1,
      itemsPerPage: 5000,
      options: {
        page: 1,
        itemsPerPage: 50,
        sortDesc: [false],
      },
      totalLength: 0,

      selectedDateTrunc: "day",
      debounceTimeout: null,
    };
  },
  computed: {
    ...mapState({
      domains: (state) => state.domain.domains,
      userId: (state) => state.user.user?.id,
    }),
    ...mapGetters([
      "roles",
      "getClients",
      "clientUid",
      "selectedDomainWebsite",
      "selectedDomainById",
    ]),
    datePickerRangeText() {
      return this.datePicker.join(" ~ ");
    },
    areAllClientsSelected() {
      return this.getClients.length === this.selectedClient.length;
    },
    areAllDomainsSelected() {
      return this.domains.length === this.selectedDomain.length;
    },
    areAllGroupBySelected() {
      return this.selectedGroupBy.length === this.itemsToGroupBy.length;
    },
    isModerRole() {
      return this.roles.includes("moder");
    },
  },
  created() {
    const echoInstance = new EchoService();

    echoInstance.listen("files", ".file.status-updated", (response) => {
      if (response?.status === "ready" || response?.status === "failed") {
        this.loading = false;
      }

      if (response?.status === "failed") {
        this.failureMessage = "Failed to generate file.";
        this.failure = true;
      }

      if (response?.status === "ready" && this.userId === response?.userId) {
        try {
          this.openTab(response.link);
        } catch (e) {
          throw new Error(e?.message || e);
        }
      }
    });
  },
  mounted() {
    if (this.isModerRole) {
      this.getAllClients();
      this.headers.unshift({
        text: "Client",
        value: "client_uid",
        sortable: true,
        align: "left",
        width: "130px",
        class: "table-header--color",
      });
    }

    this.show();
  },
  methods: {
    ...mapActions([
      "show",
      "obtainSelectedClientsDomains",
      "getAllClients",
      "obtainClientDomains",
      "getDripGroups",
      "getRecurringDrips",
      "logout",
    ]),
    applySettings() {
      let isFormValid = this.$refs.form.validate();

      if (isFormValid) {
        this.getData();
      } else {
        this.failureMessage = "Fill the form with the required fields.";
        this.failure = true;

        throw new Error("Fill the form with the required fields.");
      }
    },
    setDateRangePreset(preset) {
      const today = moment();
      let start = null;
      let end = null;

      switch (preset) {
        case "Today":
          start = today.clone().startOf("day");
          end = today;
          break;

        case "Yesterday":
          start = today.clone().subtract(1, "day").startOf("day");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 7 days":
          start = today.clone().subtract(7, "days").startOf("day");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "This month":
          start = today.clone().startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last month":
          start = today.clone().startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 30 days":
          start = today.clone().subtract(30, "days").startOf("day");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 3 months":
          start = today.clone().subtract(3, "months").startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        case "Last 6 months":
          start = today.clone().subtract(6, "months").startOf("month");
          end = today.clone().subtract(1, "day").startOf("day");
          break;

        default:
          console.error("Unknown preset:", preset);
          return;
      }

      this.datePicker = [start.format("YYYY-MM-DD"), end.format("YYYY-MM-DD")];
    },
    formatDate(date) {
      return this.selectedDateTrunc === "day"
        ? moment(date).format("YYYY-MM-DD")
        : moment(date).format("YYYY-MM-DD hh:mm:ss");
    },
    getResponseSorting() {
      if (!this.items.length) {
        this.failureMessage = "Unable to sort due to invalid data.";
        this.failure = true;

        throw new Error("Unable to sort due to invalid data.");
      }

      let { sortBy, sortDesc } = this.options;
      let keysMapping = {
        date: "timestamp",
        client: "client_id",
      };

      return sortBy.length && sortDesc.length
        ? new Array({
            [keysMapping[sortBy[0]] || sortBy[0]]: sortDesc[0] ? "DESC" : "ASC",
          })
        : [];
    },
    filteredClientName(clientUid) {
      if (!clientUid) {
        throw new Error("Invalid clientUid provided.");
      }

      return this.getClients.filter((el) => el.client_uid === clientUid)?.[0]
        ?.name;
    },
    formatNumberWithCommas(number) {
      const convertedToNumber = number ? new Number(number) : 0;

      return convertedToNumber.toLocaleString();
    },
    async prepareRequestData() {
      const orders = this.items.length ? await this.getResponseSorting() : [];
      const columns = {
        map: { timestamp: "date" },
        //include: this.isModerRole ? ["client"] : [],
      };
      let params = {
        paginate: true,
        pageLength: this.itemsPerPage,
        page: this.page,
      };

      if (!this.selectedDomain?.length || !this.selectedDomain) {
        this.failureMessage = "Invalid domain website id provided.";
        this.failure = true;

        throw new Error("Invalid domain website id provided.");
      }

      const payload = {
        timezone: this.selectedTimezone,
        date_trunc: this.selectedDateTrunc,
        columns: columns,
        filters: {
          date_start: moment(this.datePicker[0]).format("YYYY-MM-DD"),
          date_end: moment(this.datePicker[1]).format("YYYY-MM-DD"),
          campaign_uid: this.areAllDomainsSelected ? [] : this.selectedDomain,
          type: this.selectedGroupBy,
        },
        orders: orders,
        //groups: this.selectedGroupBy.length ? ['type'] : [],
      };

      if (this.isModerRole) {
        payload.filters.client_uid = this.areAllClientsSelected
          ? []
          : this.selectedClient;
      } else {
        payload.filters.client_uid = new Array(this.clientUid);
      }

      params = await serializeObjToQueryParams(params);

      return {
        payload,
        params,
      };
    },
    async getData() {
      let { payload, params } = await this.prepareRequestData();
      params = params.substring(1);

      this.sendRequest({ payload, params: `&${params}` });
    },
    async exportData() {
      let isFormValid = this.$refs.form.validate();

      if (!this.items.length) {
        this.failureMessage =
          "No data available. Please ensure you have the required data before attempting to retrieve the file.";
        this.failure = true;
        throw new Error(
          "No data available. Please ensure you have the required data before attempting to retrieve the file."
        );
      }

      if (!isFormValid) {
        throw new Error("Fill the form with the required fields.");
      }
      const { payload } = await this.prepareRequestData();

      this.sendRequest({ payload, file: true });
    },
    sendRequest({ payload, file = false, params = "" }) {
      this.loading = true;

      return Statistics.getServerPerformance({ payload, file, params })
        .then((response) => {
          console.log("🚀 ~ .then ~ response:", response);
          try {
            if (!file) {
              this.totalLength = response.data.meta.total;
              this.$set(this, "totalItems", response.data.meta.totals);
              this.items = response.data.data;
            } else {
              //this.openTab(response.data.data.path);
            }
          } catch (e) {
            throw new Error(e?.message || e);
          }
        })
        .catch((error) => {
          this.failureMessage = error?.response?.message || error;
          this.failure = true;
          throw new Error(error?.response?.message || error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onPageChange(newPage) {
      this.page = newPage;
      this.getData();
    },
    onItemsPerPageChange(newPerPage) {
      this.itemsPerPage = newPerPage;
      this.page = 1;
      this.getData();
    },
    toggleClientsSelectAll(isChecked) {
      if (isChecked) {
        this.selectedClient = this.getClients.map(
          (client) => client.client_uid
        );
      } else {
        this.selectedClient = [];
      }
    },
    toggleDomainsSelectAll(isChecked) {
      if (isChecked) {
        this.selectedDomain = this.domains.map((domain) => domain.website_id);
      } else {
        this.selectedDomain = [];
      }
    },
    toggleGroupBySelectAll(isChecked) {
      if (isChecked) {
        this.selectedGroupBy = this.itemsToGroupBy.map((el) => el.value);
      } else {
        this.selectedGroupBy = [];
      }
    },
    filterDomains(item, queryText, itemText) {
      if (!queryText) return true;

      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.id == queryText ||
        item.website_id == queryText
      );
    },
  },
  watch: {
    selectedDateRangePreset(preset) {
      if (preset) {
        this.setDateRangePreset(preset);
      }
    },
    selectedClient(client) {
      if (client) {
        try {
          this.selectedDomain = [];
          this.loading = true;

          clearTimeout(this.debounceTimeout);
          this.debounceTimeout = setTimeout(() => {
            this.obtainSelectedClientsDomains({
              selectedClients: client,
            }).finally(() => {
              this.loading = false;
            });
          }, 500);
        } catch (e) {
          this.failureMessage = e?.message || e;
          this.failure = true;
          throw new Error(e?.message || e);
        }
      }
    },
    options: {
      handler(options) {
        this.applySettings();
      },
      deep: true,
    },
  },
};
</script>

<style>
.pagination-btns {
  position: fixed !important;
  bottom: 23px;
  z-index: 10;
}

.chevron--left {
  right: 82px;
}

.chevron--right {
  right: 37px;
}
</style>